<template>
  <div
    :class="[
      classNameBase.rootElement,
      `${classNameBase.rootElement}${classNameDirection[isYouSent]}`
    ]"
    :style="isYouSent ? { backgroundColor: colorCode } : {}"
  >
    <p v-if="message" data-translate-skip>{{ message }}</p>
  </div>
</template>

<script lang="ts">
import commons from "@/common/store/modules/commons";
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    messageData: { type: Object, required: true },
    classNameDirection: { type: Object, required: true },
    isYouSent: { type: Boolean, required: true },
  }
})
export default class J05ChatScreenPanelMessageBody extends Vue {
  messageData!: any;
  classNameDirection!: any;
  isYouSent!: boolean;

  classNameBase = {
    rootElement: "p-the-j05-chat-screen-panel-message-body"
  };

  get message() {
    return this.messageData.message;
  }

  get colorCode() {
    return commons.thanksMessageColorCode;
  }
}
</script>

<style lang="scss" scoped>
.p-the-j05-chat-screen-panel-message-body {
  overflow-wrap: anywhere;
  word-break: break-word;
  border: 1px solid $common-gray300;
  @include pc {
    padding: rem(8) rem(12);
    font-size: rem(14);
    min-height: rem(32);
    border-radius: rem(12);
  }
  @include sp {
    padding: rem(8) rem(12);
    font-size: rem(11);
    min-height: rem(32);
    border-radius: rem(8);
  }
  line-height: 1.6;
  display: block;
  white-space: pre-wrap;

  &--l {
    background-color: $common-gray100;
  }

}

p {
  margin: 0;
}

</style>
